import { render, staticRenderFns } from "./editPaxelRecycleWasteType.vue?vue&type=template&id=5e0cdd1a&"
import script from "./editPaxelRecycleWasteType.vue?vue&type=script&lang=js&"
export * from "./editPaxelRecycleWasteType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports